import { get } from '../api';
import { Notification } from '@utils/';

export const getClientes = async () => {
  const res = await get('/api/clientes');

  return res.map((item) => ({
    key: `${item.cdCliente}-${item.database}-`,
    value: item.cdCliente,
    title: item.nmCliente,
  }));
};

export const getTodosClientes = async () => {
  try {
    let res = await get('/api/clientes/todos');

    res = [{ cdCliente: -1, nmCliente: 'Não cadastrado' }, ...res];

    return res.map((item) => ({
      key: `${item.cdCliente}-${item.nmBanco}`,
      value: item.cdCliente,
      title: item.nmCliente,
    }));
  } catch (e) {
    Notification.error(e.message);
  }
};

export const getClientesConectores = async () => {
  const res = await get('/api/clientes/conectores');

  return res.map((item) => ({
    key: `${item.cdCliente}-0`,
    value: `${item.cdCliente}-0`,
    title: item.nmCliente,
    children: item.conectores.map((subItem) => ({
      key: `${item.cdCliente}-${subItem.id}`,
      value: `${item.cdCliente}-${subItem.id}`,
      title: subItem.conectorIdentify,
    })),
  }));
};
